import { render } from "./AiKnowledgePage.vue?vue&type=template&id=027640f2&scoped=true"
import script from "./AiKnowledgePage.vue?vue&type=script&lang=js"
export * from "./AiKnowledgePage.vue?vue&type=script&lang=js"

import "./AiKnowledgePage.vue?vue&type=style&index=0&id=027640f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-027640f2"]])

export default __exports__